import React, { useState, useEffect } from 'react'
import { CompHSChat } from '../components/CompHSChat'
//import { UserAuth } from '../context/AuthContext'
import FormEAPSupport from './FormEAPSupport'
import CompEAPSupport from './CompEAPSupport'
import { UserAuth } from '../context/AuthContext'
import CompGenCards from '../components/CompGenCards'

import { motion } from 'framer-motion'

import CompHelpGuide from '../components/CompHelpGuide'
import { BookOpenIcon, AcademicCapIcon, ChatBubbleLeftRightIcon, ArrowRightIcon } from '@heroicons/react/24/solid'
import { query, collection, onSnapshot, orderBy, where } from 'firebase/firestore'
import { db } from '../firebase'
import { Link, useNavigate } from 'react-router-dom'
//import { useTab } from './AdminNav-v2'
//import { useTab } from '../components/AdminNav-v2'
//import { useAnimatedTabs, tabs } from '../components/AdminNav-v2'
//import {navAllStories} from '../components/AdminNav-v2'
import { useNavigation } from '../components/AdminNav-v2';
//import { Skeleton } from '@mui/material';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import { getFunctions, connectFunctionsEmulator, httpsCallable } from 'firebase/functions';
import KanbanModal from '../components/KanbanModal';
import ReactPlayer from 'react-player'
import PathLibrary from '../components/PathLibrary'
import ReactDOM from 'react-dom'
import FeatureCard from '../components/FeatureCard';

// Custom styles for the carousel
const carouselStyles = `
  .features-carousel .react-multi-carousel-dot-list {
    position: absolute;
    bottom: 2rem;
    width: 100%;
    left: 0;
    text-align: center;
    z-index: 10;
  }
  
  .features-carousel .react-multi-carousel-dot button {
    background: #475569;
    box-shadow: none;
    width: 12px;
    height: 12px;
    margin: 0 6px;
    cursor: pointer;
    border: none;
    outline: none;
    pointer-events: auto;
    transition: all 0.3s ease;
  }
  
  .features-carousel .react-multi-carousel-dot--active button {
    background: #0ea5e9;
    transform: scale(1.2);
  }
  
  .features-carousel .react-multi-carousel-dot button:hover {
    background: #64748b;
    transform: scale(1.1);
  }
  
  .features-carousel .react-multi-carousel-item {
    min-height: 180px;
    display: flex;
    align-items: center;
  }
`;

const Home = () => {
  //const { handleTabClick } = useTab();
  const currentHour = new Date().getHours();
  const greetingMessage = currentHour >= 4 && currentHour < 12 ? 'Good morning' :
    currentHour >= 12 && currentHour <= 17 ? 'Good afternoon' :
      currentHour > 17 || currentHour < 4 ? 'Good evening' : 'Welcome';

  const { user, logOut } = UserAuth();
  const navigate = useNavigate();

  const { navAllStories } = useNavigation();

  const [isKanbanModalOpen, setIsKanbanModalOpen] = useState(false);
  const [selectedStory, setSelectedStory] = useState(null);

  // Function to open the Kanban modal with a specific story
  const openKanbanModal = (story) => {
    setSelectedStory(story);
    setIsKanbanModalOpen(true);
  };

  //const { handleTabClick } = useAnimatedTabs();

  function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
  }

  const baseColor = '#1C1C22';
  const highlightColor = '#2d2d2d';



  const messagesList = [
    // {
    //   avatar: 'AI',
    //   author: 'StoryPath.ai Team',
    //   title: 'Ready? Create Your First Story in 3 Minutes',
    //   //timestamp: '3 mins ago',
    //   timestamp: '2025-03-07',
    //   image: '/media/notifications/sp-home-sp-1.png',
    //   content: [
    //     'It only takes 3 minutes to create your first story.  Click the button below to get started.'
    //   ],
    //   link: {
    //     text: 'Create Your First Story',
    //     url: '/app/storyboard'
    //   }
    // },
    {
      avatar: 'SP',
      author: 'StoryPath.ai Team',
      video: 'https://firebasestorage.googleapis.com/v0/b/brevit3-57b00.appspot.com/o/public%2FStoryPath_Product_Overview_1.mp4?alt=media&token=3eb2d3ee-4fbd-42fc-96fa-6f93d2ad90a2',
      //video: 'https://www.youtube.com/watch?v=NX5VFpC5kmQ',
      title: 'Welcome to StoryPath',
      //timestamp: 'Just now',
      timestamp: '2025-03-07',
      image: '/media/video/video-cover.png',
      content: [
        'It only takes 3 minutes to create your first story.  Click the link below to get started.',
        // 'We are excited to help support your storytelling journey. The following resources will help you to get a jump start on your first story. Please reach out with any questions or feedback and we appreciate your participation in our Early Access Program.'
      ],
      link: {
        text: 'Create Your First Story',
        url: '/app/storyboard'
      }
    },
    // {
    //   avatar: 'AI',
    //   author: 'AI Assistant',
    //   title: 'Share has been opened!',
    //   timestamp: '2 mins ago',
    //   image: '/util/app/video-placeholder.png',
    //   content: [
    //     'I can help you create compelling stories using our advanced AI tools.',
    //     'Let me know if you need any assistance!'
    //   ]
    // },
  ];

  const [displayedMessages, setDisplayedMessages] = useState([]);
  const [messagesLoading, setMessagesLoading] = useState(true);
  const [processedRequestIds] = useState(new Set());

  // Initialize Firebase Functions
  const functions = getFunctions();
  if (process.env.NODE_ENV === 'development') {
    connectFunctionsEmulator(functions, "127.0.0.1", 5001);
  }

  const getPulseMessagesCall = httpsCallable(functions, 'getPulseMessages');

  // Update useEffect to fetch messages from Firebase
  useEffect(() => {
    const fetchMessages = async () => {
      try {
        if (!user) {
          console.log('User not authenticated');
          return;
        }

        // const requestId = Date.now().toString();
        // const result = await getPulseMessagesCall({ requestId });

        // // Check if we already processed this response
        // if (processedRequestIds.has(result.data.requestId)) {
        //   return;
        // }

        // // Process the messages
        // const messages = result.data.messages || [];
        // setDisplayedMessages(messages);

        setDisplayedMessages(messagesList);

        // // Mark this request as processed
        // processedRequestIds.add(result.data.requestId);

      } catch (error) {
        console.error('Error fetching messages:', error);
        setDisplayedMessages([]); // Set empty array on error
      } finally {
        setMessagesLoading(false);
      }
    };

    if (user) {
      fetchMessages();
    } else {
      setMessagesLoading(false);
    }
  }, [user]);

  const [stories, setStories] = useState([])
  const [storiesLoaded, setStoriesLoaded] = useState(false)

  useEffect(() => {
    setTimeout(() => {
      if (user?.uid) {
        const q = query(
          collection(db, 'stories'),
          orderBy('lastModified', 'desc'),
          where("role.owner", "array-contains", user?.uid)
        );

        const unsubscribe = onSnapshot(q, (querySnapshot) => {
          let storiesArr = [];
          querySnapshot.forEach((doc) => {
            const docData = doc.data();
            if (docData.type !== "tell") {
              storiesArr.push({ ...docData, id: doc.id });
            }
          });
          // Only keep the 3 most recent stories
          setStories(storiesArr.slice(0, 3));
          setStoriesLoaded(true);
        });
        return () => unsubscribe();
      }
    }, 250);
  }, [user]);

  // Add this tab object that matches the Stories configuration from AdminNav-v2
  const storiesTab = {
    value: "path-Stories",
    label: "Story Library",
    desc: "Stories Content",
    link: "/app/stories",
    icon: (
      <img src="/util/app/b3-admin-story-5.svg" className="h-7 " />
    )
  };

  const navigateToStories = () => {
    const storiesTab = tabs.find(tab => tab.value === "path-Stories");
    handleTabClick(storiesTab);
  };

  const responsive = {
    all: {
      breakpoint: { max: 4000, min: 0 },
      items: 1
    }
  };

  const VideoPlayer = ({ url, previewImage }) => {
    const [playing, setPlaying] = useState(false);

    return (
      <div className="relative w-full h-full">
        {!playing && (
          <div className="absolute inset-0 z-10 flex items-center justify-center">
            {/* Preview Image */}
            <div
              className="absolute inset-0 bg-cover bg-center"
              style={{
                backgroundImage: `url(${previewImage})`,
                backgroundSize: 'cover',
              }}
            />

            {/* Play Button */}
            <button
              onClick={() => setPlaying(true)}
              className="relative z-20 w-16 h-16 flex items-center justify-center bg-sky-600/90 hover:bg-sky-500 rounded-full transition-colors shadow-lg"
              aria-label="Play video"
            >
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-8 h-8 text-white ml-1">
                <path fillRule="evenodd" d="M4.5 5.653c0-1.427 1.529-2.33 2.779-1.643l11.54 6.347c1.295.712 1.295 2.573 0 3.286l-11.54 6.347c-1.25.687-2.779-.217-2.779-1.643V5.653Z" clipRule="evenodd" />
              </svg>
            </button>

            {/* Optional Overlay Gradient */}
            <div className="absolute inset-0 bg-black/20 z-10" />
          </div>
        )}

        <ReactPlayer
          url={url}
          width="100%"
          height="100%"
          playing={playing}
          controls={playing}
          className="absolute top-0 left-0 rounded-lg"
          onEnded={() => setPlaying(false)}
        />
      </div>
    );
  };



  return (
    <div className="md:h-[calc(100vh-210px)] h-[calc(100vh-100px)]   admin-scroll">
      <style>{carouselStyles}</style>

      {/* <CompGenCards /> */}

      {isKanbanModalOpen && selectedStory &&
        ReactDOM.createPortal(
          <motion.div className="fixed inset-0 z-[9999]">
            <KanbanModal
              isOpen={isKanbanModalOpen}
              onClose={() => setIsKanbanModalOpen(false)}
              story={selectedStory}
            />
          </motion.div>,
          document.body
        )
      }

      <div className="relative isolate pt-8  ">
        <div className="grid grid-cols-1 gap-8">
          {/* Top Row */}
          <div className="col-span-1">
            <div className="flex justify-between items-center  px-0 pb-12 grid  grid-cols-12">
              <div className="col-span-6">
                <p className='text-5xl leading-6 text-zinc-100 mb-4 mt-4 items-center sp-big-heading'>
                  Welcome to StoryPath
                </p>
                <p className='text-3xl leading-6 text-orange-300 mb-4 mt-12 items-center'>
                  McKinsey + Pixar for Enterprise Revenue Teams
                </p>
                <p className="mb-12 pt-4 text-zinc-400 text-lg font-normal">
                   Over the last 18 months, we've been quietly working on something new. Think McKinsey insight meets Pixar storytelling, purpose-built by GTM, for GTM. StoryPath is an AI-native platform designed to solve for the messy middle, those high-stakes moments in a deal when clarity, confidence, and internal alignment are crucial.
                </p>
                <motion.a
                  href="/app/storyboard?type=generate"
                  className="  animate-shimmer bg-gradient-to-r from-[#121216] via-[#1e1e25] to-[#121216] bg-[length:200%_100%] shadow-lg hover:bg-black/50 px-5 pr-8 py-4 text-lg rounded-lg transition-colors inline-block text-white"
                  whileHover={{ scale: 1.02 }}
                  whileTap={{ scale: 0.98 }}
                >
                  <img src="/util/app/b3-admin-surf-2.svg" className="w-10 h-10 inline-block mr-4" />
                  Ready to Dive In? <img className="h-4 w-4 inline-block ml-2" src="/util/app/b3-admin-arrow-right-sky-400.svg" />
                </motion.a>
              </div>
              {/* <div className='  flex justify-end w-full'>
                
              </div> */}


              <div className="col-span-6   pb-8 ml-24">
                <Carousel
                  responsive={responsive}
                  autoPlay={true}
                  infinite={true}
                  arrows={false}
                  showDots={true}
                  autoPlaySpeed={7500}
                  transitionDuration={500}
                  containerClass="features-carousel text-left bg-black/40 rounded-lg pb-12"
                >
                  <FeatureCard
                    iconSrc="/util/app/b3-admin-stars.svg"
                    title="Deep GTM Context"
                  >
                    Know Your <span className="text-zinc-50 italic">Context</span> (KYC) and dive to your buyer's why. Quickly discover your solution hypothesis, current to future state, value assessment, cost of inaction and art of the possible.
                  </FeatureCard>

                  <FeatureCard
                    iconSrc="/util/app/b3-admin-stars.svg"
                    title="Find Your Path"
                  >
                    Communicate with confidence - think, speak, and win like strategic advisors by turning deep understanding into stories that move people and drive decisions.
                  </FeatureCard>

                  <FeatureCard
                    iconSrc="/util/app/b3-admin-chat-msg.svg"
                    title="Co-Create with CoCo"
                  >
                    Navigate any conversation with our unified "system of intelligence & engagement" that turns deep GTM know-how into repeatable, co-created assets, boosting rep confidence and performance.
                  </FeatureCard>

                  <FeatureCard
                    iconSrc="/util/app/b3-admin-theater-3.svg"
                    title="Immersive Theater"
                  >
                    Built for the on-demand generation. Deliver interactive, visual experiences that simplify complex ideas, drive engagement and help buyer champions sell internally.
                  </FeatureCard>
                </Carousel>
              </div>



            </div>
          </div>

          {/* Bottom Columns */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 pb-12  rounded-lg bg-black/10  ">
            {/* Lower Left Column - Recent Paths */}
            <div className="md:col-span-1">
              <div className="space-y-4   rounded-lg bg-black/5x  p-4 ">
                <div className=" ">
                  <PathLibrary isHome={true} />
                </div>
              </div>
            </div>

            {/* Lower Right Column - Recent Theater Experiences */}
            <div className="md:col-span-1">
              <div className="space-y-4  pb-12">
                {/* <motion.div
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{
                    duration: 0.25,
                    ease: "easeOut"
                  }}
                > */}
                  <div className="gap-4  rounded-lg bg-black/5x  p-4 ">
                    <div>
                      <div className="flex justify-between items-center pt-1 pb-4">
                        <div className="block tracking-normal text-lg leading-relaxed text-zinc-200 inline-flex items-center">
                          <img src="/util/app/b3-admin-theater-3.svg" className="h-12 inline-block mr-3 opacity-75 rounded-full p-1" />
                          Recent Theater Experiences
                        </div>
                        <motion.div
                          whileHover={{ scale: 1.01 }}
                          whileTap={{ scale: 0.95 }}
                        >
                          <Link to="/app/storyboard?type=blank" className="px-4 py-3 text-base bg-black/10 hover:bg-black/30 text-white rounded-lg transition-colors">
                            <span className="text-sky-400 mr-2 text-xl font-bold">+</span>
                            Create New Experience
                          </Link>
                        </motion.div>
                      </div>
                      {storiesLoaded && stories.length > 0 ? (
                        <div className="md:section-scroll md:h-content mt-4  space-y-5">
                          {stories.map((story, index) => (
                            <motion.div
                              key={story.id}
                              whileHover={{ scale: 1.005 }}
                              transition={{ duration: 0.25 }}
                              className={`relative pointer-events-auto overflow-hidden rounded-lg bg-zinc-950/25 hover:bg-black/30 animate__animated animate__fadeIn`}
                            >
                              {story.type === "tell" ? (
                                <div className="rounded-lg p-4 flex items-center space-x-4">
                                  <div className="flex-shrink-0 aspect-video h-24 rounded-lg overflow-hidden relative bg-black/10">
                                    <div
                                      className="absolute inset-0 bg-cover bg-center"
                                      style={{ backgroundImage: `url(${story.previewThumb})` }}
                                    />
                                    <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-black/25 to-transparent" />
                                  </div>
                                  <div className="flex-grow">
                                    <div className="flex justify-between items-start">
                                      <div>
                                        {story.formData ? (
                                          <>
                                            <h3 className="text-zinc-50 font-semibold text-lg">
                                              {JSON.parse(story.formData).promptCustomerName}
                                            </h3>
                                            <p className="text-zinc-400 text-sm line-clamp-1 mt-1">
                                              {JSON.parse(story.formData).promptProductName}
                                            </p>
                                          </>
                                        ) : (
                                          <>
                                            <h3 className="text-white text-lg font-bold">{story.name}</h3>
                                            <p className="text-zinc-300 text-sm line-clamp-1 mt-1">
                                              {story.description || 'No description available'}
                                            </p>
                                          </>
                                        )}
                                      </div>
                                      <div className="flex flex-col items-end ml-4 flex-shrink-0">
                                        {story.visibility === 'public' ? (
                                          <div className="text-amber-500 px-2 py-1 bg-black/50 h-6 rounded text-xs">public</div>
                                        ) : (
                                          <div className="text-zinc-300 px-2 py-1 bg-black/50 h-6 rounded text-xs">private</div>
                                        )}
                                        <div className="text-zinc-100 text-xs pt-1 opacity-80 text-right">
                                          {story.createdAt && new Date(story.createdAt.seconds * 1000).toLocaleDateString("en-US", { month: 'short', day: 'numeric' })}
                                        </div>
                                      </div>
                                    </div>
                                    <div className="flex items-center mt-2">
                                      {story.userPhotoURL ? (
                                        <img
                                          referrerPolicy="no-referrer"
                                          src={story.userPhotoURL}
                                          className="w-8 h-8 rounded-full mr-2"
                                          alt="Author"
                                          onError={(e) => {
                                            e.target.style.display = 'none';
                                            e.target.nextSibling.style.display = 'flex';
                                          }}
                                        />
                                      ) : null}
                                      <div
                                        className={`w-8 h-8 rounded-full bg-sky-600 text-white flex items-center justify-center text-xs font-medium mr-2 ${story.userPhotoURL ? 'hidden' : ''}`}
                                      >
                                        {story.userName ? story.userName.split(' ').map(name => name[0]).join('').substring(0, 2).toUpperCase() : 'U'}
                                      </div>
                                      <span className="text-zinc-400 text-xs">{story.userName || 'Unknown User'}</span>
                                    </div>
                                  </div>
                                  <div className="flex flex-col space-y-2 ml-4 flex-shrink-0">
                                    <button
                                      onClick={(e) => {
                                        e.preventDefault();
                                        e.stopPropagation();
                                        openKanbanModal(story);
                                      }}
                                      className="px-3 py-1.5 bg-sky-600 hover:bg-sky-500 text-white rounded-md transition-colors duration-200 text-xs items-center justify-center cursor-pointer"
                                    >
                                      Open StoryPaths
                                    </button>
                                    <Link
                                      to={`/app/stories/${story.id}/edit/0`}
                                      className="px-3 py-1.5 bg-white/10 hover:bg-white/20 text-white rounded-md transition-colors duration-200 text-xs items-center justify-center cursor-pointer text-center"
                                    >
                                      Theater
                                    </Link>
                                  </div>
                                </div>
                              ) : (
                                <Link
                                  to={`/app/stories/${story.id}/edit/0`}
                                  key={story.id}
                                  className="rounded-lg p-4 flex items-center space-x-4"
                                >
                                  <div className={`flex-shrink-0 aspect-video ${story.backgroundSky} h-32 rounded-lg overflow-hidden relative`}>
                                    <div
                                      className={`w-full h-full bg-cover bg-center ${story.backgroundSky} overflow-hidden`}
                                      style={{
                                        backgroundImage: `url(${story.previewThumb.replace('/upload', '/upload/ar_1:1,c_fill,w_200/')})`,
                                      }}
                                    >
                                    </div>
                                  </div>
                                  <div className="flex-grow">
                                    <div className="flex justify-between items-start">
                                      <div>
                                        <h3 className="text-white text-lg font-bold">{story.name}</h3>
                                        <p className="text-zinc-300 text-sm line-clamp-1 mt-1">
                                          {story.description || 'No description available'}
                                        </p>
                                      </div>
                                      <div className="text-zinc-100 text-xs pt-1 opacity-80 text-right ml-2">
                                        {story.createdAt && new Date(story.createdAt.seconds * 1000).toLocaleDateString("en-US", { month: 'short', day: 'numeric' })}
                                      </div>
                                    </div>
                                  </div>
                                </Link>
                              )}
                              
                            </motion.div>
                            
                          ))}
                          <div className="flex justify-end">
                            <div
                              onClick={navAllStories}
                              className="px-4 py-3 text-base bg-black/10 hover:bg-black/30 text-white rounded-lg transition-colors cursor-pointer flex items-center" >
                              View All
                              <img className="h-4 w-4 inline-block ml-2" src="/util/app/b3-admin-arrow-right-sky-400.svg" />
                            </div>
                          </div>
                        </div>
                      ) : storiesLoaded ? (
                        <div className="flex flex-col items-center mt-12 -mb-12 text-center p-6">
                          <motion.div
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            transition={{ duration: 0.6 }}
                            className="flex flex-col items-center"
                          >
                            <div className="mb-4">
                              <img src="/util/app/b3-admin-story-5.svg" className="h-16 w-16 mx-auto opacity-50 bg-black/20 rounded-full p-1" alt="Create story" />
                            </div>
                            <h3 className="text-xl font-medium text-zinc-200 mb-2">No Theater Experiences Yet</h3>
                            <p className="text-zinc-400 mb-6">Start your storytelling journey by creating your first story</p>
                            <a
                              href="/app/storyboard"
                              className="px-4 py-3 text-base mb-12 bg-sky-600 hover:bg-sky-500 text-white rounded-lg transition-colors"
                            >
                              Create Your First Story
                            </a>
                          </motion.div>
                        </div>
                      ) : (
                        <div className="grid grid-cols-1 gap-4 mt-2">
                          <SkeletonTheme baseColor={baseColor} highlightColor={highlightColor}>
                            <Skeleton className="w-full rounded-lg h-36" />
                            <Skeleton className="w-full rounded-lg h-36" />
                            <Skeleton className="w-full rounded-lg h-36" />
                          </SkeletonTheme>
                        </div>
                      )}
                    </div>
                  </div>
                {/* </motion.div> */}
              </div>
            </div>
          </div>
        </div>
      </div>


    </div>
  );
};

export default Home;